"use client"
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import PartnersTermsDropdown from './_components/PartnersTermsDropdown'
import Tabs from './_components/Tabs'

const layout =  ({ children, params }) => {
    const t = useTranslations('partnersTerms')
    const { location, service } = useParams()
    return (
      <main>
        <div className='container py-24'>
          <div>
            <h3 className='heading-common mb-[65px]'>{t(`title`)}</h3>
          </div>
<PartnersTermsDropdown location={location}/>
<Tabs isShowArrows={false} />
          {children}
        </div>
      </main>
    )
  }

export default layout
